import {
  creditCardOfferMutation,
  creditCardOfferQuery,
  graphQLClient,
} from './graphQL/creditCardApply'

type QueryCreditCardOfferArgs = {
  guid: string
  accessToken: string
}

export type CreditCardOfferData = {
  isOfferAvailable: boolean
  offerDetails: {
    offerId: string
    productId: string
    presented: boolean
    productType: string
  }
}

export type CreditCardQueryResponse = {
  customerCardOffer: CreditCardOfferData
}

export async function queryCreditCardOffer({
  guid,
  accessToken,
}: QueryCreditCardOfferArgs): Promise<CreditCardOfferData> {
  return graphQLClient.request<CreditCardOfferData, { customerId: string }>(
    creditCardOfferQuery,
    {
      customerId: guid,
    },
    {
      Authorization: `Bearer ${accessToken}`,
    },
  )
}

type MutationResult = {
  setOfferPresented: {
    isSuccessful: boolean
  }
}

export interface MutateCreditCardOfferArgs {
  accessToken: string
  guid: string
  offerId: string
}

export async function mutateCreditCardOffer({
  accessToken,
  guid,
  offerId,
}: MutateCreditCardOfferArgs): Promise<boolean> {
  const mutationResponse = await graphQLClient.request<MutationResult>(
    creditCardOfferMutation,
    {
      customerId: guid,
      offerId,
    },
    {
      Authorization: `Bearer ${accessToken}`,
    },
  )

  return mutationResponse.setOfferPresented.isSuccessful
}
